var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearningPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 381",
    style: {
      enableBackground: "new 0 0 384 381"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Watch"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M193,6C92.1,6,10,88.09,10,188.99C10,289.9,92.1,372,193,372c100.91,0,183-82.1,183-183.01C376,88.09,293.91,6,193,6z  M193,349.12c-88.29,0-160.12-71.83-160.12-160.13c0-88.29,71.83-160.12,160.12-160.12c88.3,0,160.13,71.83,160.13,160.12 C353.13,277.29,281.3,349.12,193,349.12z M222.89,205.49c2.74-4.91,4.42-10.47,4.42-16.5c0-14.89-9.59-27.47-22.87-32.21v-93.6 c0-6.32-5.12-11.44-11.45-11.44c-6.32,0-11.43,5.13-11.43,11.44v93.6c-13.28,4.74-22.87,17.31-22.87,32.21 c0,18.92,15.39,34.32,34.3,34.32c4.54,0,8.86-0.93,12.83-2.54l47.71,47.71c2.24,2.24,5.16,3.35,8.09,3.35s5.86-1.11,8.09-3.35 c4.47-4.45,4.47-11.69,0-16.16L222.89,205.49z M193,200.43c-6.31,0-11.43-5.12-11.43-11.44c0-6.3,5.13-11.43,11.43-11.43 c6.32,0,11.45,5.13,11.45,11.43C204.45,195.31,199.32,200.43,193,200.43z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningPlan);
export default __webpack_public_path__ + "static/media/learningPlan.43663a065ffe812c13b73bbce4e4028a.svg";
export { ForwardRef as ReactComponent };